export function makeSearchPropDeepMapFn(prop) {
  return obj => searchPropDeep(prop, obj);
}

function searchPropDeep(propName, obj) {
  let props = propName.split(".");

  for (let i = 0; i < props.length; i++) {
    if (!obj) {
      return null;
    }

    if (typeof obj === "object") {
      obj = obj[props[i]];
    }
  }

  return obj;
}

export function sortByMapping(originalData, mapFn, reverse = false) {
  let data = originalData.slice(0);
  let order = reverse ? -1 : 1;

  return data.sort((a, b) => {
    let aProp = mapFn(a);
    let bProp = mapFn(b);

    if (typeof aProp === "string") aProp = aProp.toLowerCase();
    if (typeof bProp === "string") bProp = bProp.toLowerCase();

    if (aProp > bProp || (aProp === null && bProp)) {
      return order;
    } else if (aProp < bProp || (aProp && bProp === null)) {
      return order * -1;
    } else {
      return 0;
    }
  });
}

export function sortByProperty(originalData, prop, reverse = false) {
  const mapFn = makeSearchPropDeepMapFn(prop);
  return sortByMapping(originalData, mapFn, reverse);
}



// WEBPACK FOOTER //
// ./src/utils.js